<template>
    <v-form v-model="formValidity" ref="mediaForm">
        <v-layout row wrap>
            <v-flex xs12 sm4 md2 px-2>
                <v-select
                    v-model="mediaSubmission.mediaType"
                    item-text="description"
                    item-value="mediaTypeId"
                    :items="mediaTypes"
                    label="Media Type"
                    :disabled="disabled"
                >
                </v-select>
            </v-flex>
            <v-flex xs3 sm2 md1 px-2 v-if="isMediaTypeDriversLicense(mediaSubmission.mediaType)">
                <v-select
                    v-model="mediaSubmission.licenseState"
                    :items="states"
                    item-value="id"
                    item-text="description"
                    label="State"
                    :disabled="disabled"
                >
                </v-select>
            </v-flex>
            <v-flex xs9 sm6 md2 px-2 v-if="isMediaTypeDriversLicense(mediaSubmission.mediaType)">
                <v-text-field
                    label="License Number"
                    v-mask="getStateLicenseMask(mediaSubmission.licenseState)"
                    :placeholder="getStateLicenseMask(mediaSubmission.licenseState)"
                    :rules="validateLicense(mediaSubmission.licenseState, mediaSubmission.licenseNumber)"
                    required
                    v-model="mediaSubmission.licenseNumber"
                    :disabled="disabled"
                ></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 md5 px-2>
                <v-file-input
                    small-chips
                    counter
                    show-size
                    accept="image/*"
                    v-model="mediaSubmission.media"
                    label="All Image Types are Acceptable"
                    :disabled="disabled"
                ></v-file-input>
            </v-flex>
            <v-flex xs12 sm4 md2 px-2>
                <v-btn :disabled="disabled" @click="upload()">Upload Image</v-btn>
            </v-flex>
            <v-flex xs12>
                <v-data-table :items="mediaList" :headers="mediaListHeaders" no-data-text="No files available">
                    <template #[`item.view`]="{ item }">
                        <td>
                            <v-btn :icon="true" @click="download(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn>
                        </td>
                    </template>
                    <template #[`item.azureSasLink`]="{ item }">
                        <td><img :src="item.azureSasLink" width="80" height="80" /></td>
                    </template>
                    <template #[`item.delete`]="{ item }">
                        <td>
                            <v-btn :disabled="disabled" :icon="true" @click="deleteMedia(item)"
                            ><v-icon dark>mdi-trash-can-outline</v-icon></v-btn
                            >
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
import mediaService from '@/services/mediaService'
import lookupService from '@/services/lookupService'
import driversLicenseService from '@/services/util/driversLicenseService'
import { mask } from 'vue-the-mask'

export default {
    name: 'media-uploader',
    directives: {
        mask
    },
    props: {
        disabled: Boolean,
        moduleId: Number,
        parentId: Number
    },
    mounted () {
        this.mediaSubmission.moduleId = this.moduleId
        this.mediaSubmission.parentId = this.parentId
        this.load()
        this.loadMedia()
    },
    data: () => {
        return {
            formValidity: false,
            mediaList: [],
            mediaListHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Media', value: 'azureSasLink' },
                { text: 'File Name', value: 'filename' },
                { text: 'Create Date', value: 'createDate' },
                { text: 'Delete', value: 'delete' }
            ],
            mediaTypes: [],
            states: [],
            licenseStateFormats: [],
            mediaSubmission: {
                mediaType: null,
                media: null,
                parentId: null,
                moduleId: null,
                licenseNumber: null,
                licenseState: null
            }
        }
    },
    methods: {
        load () {
            mediaService.getMediaTypes(this.$http, this.moduleId).then(response => {
                this.mediaTypes = response.data
            })
            lookupService.GetStateAbbrs(this.$http).then(response => {
                this.states = response.data
            })
            this.licenseStateFormats = driversLicenseService.states
        },
        loadMedia () {
            if (this.mediaSubmission.parentId && this.mediaSubmission.moduleId) {
                mediaService.getMediaByParent(this.$http, this.mediaSubmission.parentId, this.mediaSubmission.moduleId).then(response => {
                    this.mediaList = response.data
                })
            }
        },
        upload () {
            if (this.$refs.mediaForm.validate()) {
                this.$emit('on-upload')
            }
        },
        saveMedia (parentId, moduleId) {
            if (!this.mediaSubmission.media) return
            this.mediaSubmission.parentId = parentId
            this.mediaSubmission.moduleId = moduleId
            var formData = new FormData()
            formData.append(this.mediaSubmission.media.name, this.mediaSubmission.media)
            formData.append('mediaType', this.mediaSubmission.mediaType)
            formData.append('moduleId', this.mediaSubmission.moduleId)
            formData.append('parentId', this.mediaSubmission.parentId)
            formData.append('licenseNumber', this.mediaSubmission.licenseNumber)
            formData.append('licenseState', this.mediaSubmission.licenseState)
            return mediaService.saveMedia(this.$http, formData, this.mediaSubmission).then(() => {
                this.loadMedia()
                this.mediaSubmission.mediaType = null
                this.mediaSubmission.media = null
                this.mediaSubmission.licenseState = null
                this.mediaSubmission.licenseNumber = null
            })
        },
        download (media) {
            mediaService.getMediaToDownload(this.$http, media.mediaId).then(response => {
                mediaService.downloadMedia(media.mimeType.contentType, response.data, media.filename)
            })
        },
        deleteMedia (media) {
            mediaService.removeMedia(this.$http, media.mediaId).then(() => {
                this.loadMedia()
            })
        },
        isMediaTypeDriversLicense (type) {
            return mediaService.isMediaTypeDriversLicense(type)
        },
        getStateLicenseMask (state) {
            var obj = this.licenseStateFormats.find(x => x.Id === state)
            return obj ? obj.Mask : 'XXXXXXXXXXXXXXXX' // If state validation not set 15 chars of Any symbol (New Jersey can be 15)
        },
        validateLicense (state, license) {
            return [driversLicenseService.validateLicense(state, license) || 'Incorrect license format']
        }
    },
    watch: {
        moduleId: {
            handler (value) {
                this.mediaSubmission.moduleId = value
                this.loadMedia()
            },
            deep: false
        },
        parentId: {
            handler (value) {
                this.mediaSubmission.parentId = value
                this.loadMedia()
            },
            deep: false
        }
    }
}
</script>

<style></style>
